import { useEffect, useRef } from 'react';

export const useIsKeyboardNavigation = (): boolean => {
  const triggeredByKeyboard = useRef<boolean>(false);

  // Detect whether the user is using the keyboard or mouse to navigate the page
  useEffect(() => {
    const onKeyDownHandler = (event: KeyboardEvent) => {
      if (event.code === 'Tab') {
        triggeredByKeyboard.current = true;
      }
    };
    const onMouseDownHandler = () => {
      triggeredByKeyboard.current = false;
    };

    document.addEventListener('keydown', onKeyDownHandler);
    document.addEventListener('mousedown', onMouseDownHandler);
    return () => {
      document.removeEventListener('keydown', onKeyDownHandler);
      document.removeEventListener('mousedown', onMouseDownHandler);
    };
  }, []);
  return triggeredByKeyboard.current;
};
